function SuccessScreen() {
    return <div className={'success-screen'}>
        <header>Vielen Dank</header>
        <p>Wir bearbeiten Ihre Anfrage und melden uns zeitnah bei Ihnen.</p>
    </div>;
}

export default SuccessScreen;